module.exports = __webpack_public_path__ + "img/facility-vector.6a448596.png";